'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var propTypes = {
  fluid: _react.PropTypes.bool,
  className: _react.PropTypes.node
};

var defaultProps = {};

var Container = function Container(props) {
  var className = props.className;
  var fluid = props.fluid;

  var attributes = _objectWithoutProperties(props, ['className', 'fluid']);

  var classes = (0, _classnames2.default)(className, fluid ? 'container-fluid' : 'container');

  return _react2.default.createElement('div', _extends({}, attributes, { className: classes }));
};

Container.propTypes = propTypes;
Container.defaultProps = defaultProps;

exports.default = Container;


/*****************
 ** WEBPACK FOOTER
 ** ./~/reactstrap/lib/Container.js
 ** module id = 168
 ** module chunks = 0
 **/